import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const SAVE_DRAFT_OVERRIDES_REQUEST = 'SAVE_DRAFT_OVERRIDES_REQUEST';
export const SAVE_DRAFT_OVERRIDES_SUCCESS = 'SAVE_DRAFT_OVERRIDES_SUCCESS';
export const SAVE_DRAFT_OVERRIDES_FAILURE = 'SAVE_DRAFT_OVERRIDES_FAILURE';

function request() {
  return {
    type: SAVE_DRAFT_OVERRIDES_REQUEST,
    isSavingValidationOverrides: true,
  };
}

function receive(draftOverrides, accountId, formId) {
  return {
    type: SAVE_DRAFT_OVERRIDES_SUCCESS,
    isSavingValidationOverrides: false,
    draftOverrides,
    accountId,
    formId,
    validationOverridesError: null
  };
}

function reject(validationOverridesError) {
  return {
    type: SAVE_DRAFT_OVERRIDES_FAILURE,
    isSavingValidationOverrides: false,
    validationOverridesError
  };
}

export function saveDraftValidationOverrides(formId, accountId, data) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .saveDraftValidationOverrides(formId, accountId, data)
      .then((response) => {
        dispatch(receive(data, accountId, formId));
        toastr.success('Success', 'Your draft validation overrides have been saved.');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
